// Third party
import { useMutation } from '@tanstack/react-query';

// API
import { useNavigate } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { LoginController } from '../../services';

// Types
import { IBaseResponse, TAxiosError } from '../../types/responses';
import { TResetPass } from '../../types/requests';
import { useError } from '../useCommon';

export function useForgotAPI() {
  const navigation = useNavigate();
  const { handleReqError } = useError();
  const posthog = usePostHog();

  const forgotPass = async (email: string) => {
    const data = {
      email,
    };
    return LoginController().forgotPass<IBaseResponse>(data);
  };

  return useMutation(forgotPass, {
    onSuccess: (rsp, variables) => {
      posthog.capture('ManageMate_web', {
        email: variables,
        addedAt: new Date().toISOString(),
        action: 'user_forgot_password',
      });

      if (rsp?.success) {
        navigation('/check-email');
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error, { email: variables, route: 'forgot' });
      } else if ('msg' in rsp) {
        console.error(`ERROR! forgot password failed! ${rsp.msg}`);
      }
    },
    onError: (error: TAxiosError) => {
      console.error(`ERROR! forgot request threw an Exception! ${error}`);
    },
  });
}

export function useResetPassAPI() {
  const navigation = useNavigate();
  const { handleReqError } = useError();

  const resetPass = async (data: TResetPass) => LoginController().resetPass<IBaseResponse>(data);

  return useMutation(resetPass, {
    onSuccess: (rsp) => {
      if (rsp?.success) {
        navigation('/');
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error);
      } else if ('msg' in rsp) {
        console.error(`ERROR! reset password failed! ${rsp.msg}`);
      }
    },
    onError: (error: TAxiosError) => {
      console.error(`ERROR! reset password request threw an Exception! ${error}`);
    },
  });
}
